import { useEffect, useState } from 'react';
import { useLanguage } from '@/i18n/LanguageContext';
import { registryApi } from '@/features/publicsite/registry/api/registryApi';
import type { Advisor } from '@/features/publicsite/types/registry/Advisor';

/**
 * The advisers matching a search and a domain of competence (all of them for ''), reloaded when
 * either of them or the language changes.
 *
 * Same rule as the catalogue pages: `null` is "not loaded", `[]` is "loaded and empty", and the
 * two have to stay distinct or the empty state shows during the fetch.
 */
export function useAdvisors(query: string, domain: string): Advisor[] | null {
  const { language } = useLanguage();
  const [items, setItems] = useState<Advisor[] | null>(null);
  useEffect(() => {
    let live = true;
    setItems(null);
    registryApi.advisors(query, domain).then((r) => {
      if (live) setItems(r);
    });
    return () => {
      live = false;
    };
  }, [query, domain, language]);
  return items;
}
